import React from 'react';

const Payments: React.FC = () => {
  return <div>Payment Component</div>;
};

export default Payments;
